import UspList from "../../../components/general/UspList";
import { notNull, notUndefined } from "../../../utils/type-guards/general";

const UspListModule = ({ usps }: Queries.UspListFragment) => {
	const filteredUsps =
		usps
			?.map((usp) => usp?.text)
			.filter(notUndefined)
			.filter(notNull) ?? [];
	return usps ? <UspList usps={filteredUsps} /> : null;
};
export default UspListModule;
